/* Weaving Creation — PDP extras: gallery (swipe + zoom), size-guide modal, recently viewed + related products sliders */
(function () {
  "use strict";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  // ---- Gallery: sideways swipe + thumbnails + click-to-zoom ----
  var gal = document.querySelector("[data-gallery]");
  if (gal) {
    var stage = gal.querySelector("[data-gallery-stage]");
    var slides = [].slice.call(gal.querySelectorAll("[data-gallery-slide]"));
    var thumbs = [].slice.call(gal.querySelectorAll("[data-gallery-thumb]"));
    var setActive = function (i) {
      slides.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle("is-active", idx === i); });
    };
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var i = parseInt(t.getAttribute("data-index"), 10) || 0;
        if (slides[i] && stage) stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: "smooth" });
        setActive(i);
      });
    });
    if (stage) {
      var st;
      stage.addEventListener("scroll", function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var center = stage.scrollLeft + stage.clientWidth / 2, best = 0, bestd = Infinity;
          slides.forEach(function (s, idx) {
            var c = s.offsetLeft - stage.offsetLeft + s.clientWidth / 2, d = Math.abs(c - center);
            if (d < bestd) { bestd = d; best = idx; }
          });
          setActive(best);
        }, 80);
      }, { passive: true });
    }
    slides.forEach(function (s) {
      s.addEventListener("click", function () { openZoom(s.getAttribute("data-full")); });
    });
  }

  function openZoom(src) {
    if (!src) return;
    var returnFocus = document.activeElement;
    var ov = document.createElement("div");
    ov.className = "wc-zoom";
    ov.setAttribute("role", "dialog");
    ov.setAttribute("aria-modal", "true");
    ov.setAttribute("aria-label", "Zoomed product image");
    ov.innerHTML = '<button class="wc-zoom__x" aria-label="Close">&times;</button><img class="wc-zoom__img" src="' + esc(src) + '" alt="">';
    document.body.appendChild(ov);
    document.documentElement.style.overflow = "hidden";
    var img = ov.querySelector("img"), closeBtn = ov.querySelector(".wc-zoom__x"), zoomed = false;
    if (closeBtn) closeBtn.focus();
    function close() { ov.remove(); document.documentElement.style.overflow = ""; document.removeEventListener("keydown", onKey); if (returnFocus && returnFocus.focus) returnFocus.focus(); }
    function onKey(e) { if (e.key === "Escape") close(); else if (e.key === "Tab") { e.preventDefault(); if (closeBtn) closeBtn.focus(); } }
    function origin(e) {
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + "% " + ((e.clientY - r.top) / r.height * 100) + "%";
    }
    ov.addEventListener("click", function (e) { if (e.target === ov || e.target.classList.contains("wc-zoom__x")) close(); });
    img.addEventListener("click", function (e) {
      e.stopPropagation(); zoomed = !zoomed; img.classList.toggle("is-zoomed", zoomed);
      if (zoomed) origin(e); else img.style.transformOrigin = "center";
    });
    img.addEventListener("mousemove", function (e) { if (zoomed) origin(e); });
    document.addEventListener("keydown", onKey);
  }

  // ---- Enlarge add-on product images (kippah / bags) — Yosef 2026-07-28 ----
  document.querySelectorAll("[data-addon-zoom]").forEach(function (z) {
    var open = function (e) { e.preventDefault(); e.stopPropagation(); openZoom(z.getAttribute("data-addon-zoom")); };
    z.addEventListener("click", open);
    z.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") open(e); });
  });

  // ---- Customize drawer (DRAWER TRIAL 2026-08-02): options in a slide-in panel, CTA stays visible ----
  var drawer = document.querySelector("[data-drawer]");
  if (drawer) {
    var openDrawer = function () { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add("is-open"); }); document.documentElement.style.overflow = "hidden"; };
    var closeDrawer = function () { drawer.classList.remove("is-open"); document.documentElement.style.overflow = ""; setTimeout(function () { drawer.hidden = true; }, 320); };
    document.querySelectorAll("[data-drawer-open]").forEach(function (b) { b.addEventListener("click", openDrawer); });
    document.querySelectorAll("[data-drawer-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("is-open")) closeDrawer(); });
  }

  // ---- Size-guide modal (image and/or video, per product) ----
  var sgModal = document.querySelector("[data-size-guide-modal]");
  function sgVideoEmbed(url) {
    var u = (url || "").trim();
    var yt = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{11})/);
    if (yt) return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '" title="Size guide" allow="accelerometer; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
    var vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return '<iframe src="https://player.vimeo.com/video/' + vm[1] + '" title="Size guide" allowfullscreen loading="lazy"></iframe>';
    if (/\.mp4(\?|$)/i.test(u)) return '<video src="' + esc(u) + '" controls playsinline></video>';
    return '<a href="' + esc(u) + '" target="_blank" rel="noreferrer">Watch the size guide video &rarr;</a>';
  }
  document.querySelectorAll("[data-size-guide]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (!sgModal) return;
      var vc = sgModal.querySelector("[data-sg-video]");
      if (vc && vc.getAttribute("data-video-url") && !vc.getAttribute("data-built")) {
        vc.innerHTML = sgVideoEmbed(vc.getAttribute("data-video-url"));
        vc.setAttribute("data-built", "1");
      }
      sgModal.hidden = false; document.documentElement.style.overflow = "hidden";
    });
  });
  document.querySelectorAll("[data-size-guide-close]").forEach(function (b) {
    b.addEventListener("click", function () { if (sgModal) { sgModal.hidden = true; document.documentElement.style.overflow = ""; } });
  });

  // ---- Generic policy modals (Shipping / Returns / Care / FAQ) ----
  document.querySelectorAll("[data-modal]").forEach(function (b) {
    b.addEventListener("click", function () {
      var panel = document.querySelector('[data-modal-panel="' + b.getAttribute("data-modal") + '"]');
      if (panel) { panel.hidden = false; document.documentElement.style.overflow = "hidden"; }
    });
  });
  document.querySelectorAll("[data-modal-close]").forEach(function (b) {
    b.addEventListener("click", function () {
      var panel = b.closest("[data-modal-panel]");
      if (panel) { panel.hidden = true; document.documentElement.style.overflow = ""; }
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll("[data-modal-panel]").forEach(function (p) { p.hidden = true; });
    if (sgModal) sgModal.hidden = true;
    document.documentElement.style.overflow = "";
  });

  function initNav(slider, track) {
    if (!slider || !track) return;
    if (slider.querySelector(".pdp-slider__nav")) return;
    if (track.scrollWidth <= track.clientWidth + 8) return; // nothing to scroll
    function mk(dir) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pdp-slider__nav pdp-slider__nav--" + (dir < 0 ? "prev" : "next");
      b.setAttribute("aria-label", dir < 0 ? "Previous" : "Next");
      b.innerHTML = dir < 0 ? "&#8249;" : "&#8250;";
      b.addEventListener("click", function () {
        track.scrollBy({ left: dir * Math.max(240, track.clientWidth * 0.8), behavior: "smooth" });
      });
      return b;
    }
    slider.appendChild(mk(-1));
    slider.appendChild(mk(1));
  }

  // ---- Mobile-only auto-advance for a pdp-slider (arrows are hidden < 700px) ----
  var mqMobile = window.matchMedia("(max-width: 700px)");
  function motionOff() {
    return (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      || document.documentElement.classList.contains("a11y-motion");
  }
  function initAutoScroll(slider, track) {
    if (!slider || !track) return;
    if (slider.__wcAuto) slider.__wcAuto();            // tear down a prior run (track may have been replaced)
    var paused = false, visible = true, resumeT = null, io = null;
    function shouldRun() {
      return mqMobile.matches && visible && !paused && !document.hidden && !motionOff()
        && track.scrollWidth > track.clientWidth + 8;
    }
    function step() {
      var item = track.querySelector(".pdp-slider__item");
      var stepPx = item ? Math.round(item.getBoundingClientRect().width + 16) : Math.round(track.clientWidth * 0.85);
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) {
        track.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        track.scrollBy({ left: stepPx, behavior: "smooth" });
      }
    }
    var id = setInterval(function () { if (shouldRun()) step(); }, 3800);
    function pauseNow() { paused = true; if (resumeT) clearTimeout(resumeT); }
    function resumeSoon() { if (resumeT) clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, 5000); }
    track.addEventListener("touchstart", pauseNow, { passive: true });
    track.addEventListener("touchend", resumeSoon, { passive: true });
    track.addEventListener("pointerdown", pauseNow);
    track.addEventListener("pointerup", resumeSoon);
    track.addEventListener("wheel", function () { pauseNow(); resumeSoon(); }, { passive: true });
    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; }); }, { threshold: 0.15 });
      io.observe(slider);
    }
    slider.__wcAuto = function () { clearInterval(id); if (io) io.disconnect(); };
  }

  var KEY = "wc-recently-viewed";

  // ---- Recently viewed ----
  var curEl = document.querySelector("[data-recent-current]");
  var cur = null;
  if (curEl) { try { cur = JSON.parse(curEl.textContent); } catch (e) {} }

  if (cur && cur.h) {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || "[]");
      list = list.filter(function (x) { return x && x.h !== cur.h; });
      list.unshift(cur);
      list = list.slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  var recentSection = document.querySelector("[data-recent-section]");
  if (recentSection) {
    var rTrack = recentSection.querySelector("[data-recent-track]");
    var items = [];
    try { items = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) {}
    items = items.filter(function (x) { return x && x.h && (!cur || x.h !== cur.h); }).slice(0, 12);
    if (items.length && rTrack) {
      rTrack.innerHTML = items.map(function (x) {
        return '<a class="pcard pdp-slider__item" href="' + esc(x.u) + '">' +
          '<div class="pcard__media">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" width="600" height="800">' : "") + "</div>" +
          '<div class="pcard__body"><h3 class="pcard__title">' + esc(x.t) + '</h3><p class="pcard__price">' + esc(x.p) + "</p></div></a>";
      }).join("");
      recentSection.hidden = false;
      initNav(recentSection.querySelector(".pdp-slider"), rTrack);
    }
  }

  // ---- Related products (Shopify recommendations API) ----
  var rel = document.querySelector("[data-related]");
  if (rel && rel.dataset.url) {
    var existing = rel.querySelector("[data-slider-track]");
    var hasFallback = !!(existing && existing.hasAttribute("data-fallback"));
    // a server-rendered track (real or fallback) still needs its arrows wired up
    if (existing) { initNav(rel, existing); initAutoScroll(rel, existing); }
    // only ask the recommendations API when we have nothing real yet
    if (!existing || hasFallback) {
      fetch(rel.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var dom = new DOMParser().parseFromString(html, "text/html");
          var track = dom.querySelector("[data-slider-track]");
          var section = rel.closest("[data-related-section]");
          if (track && track.children.length && !track.hasAttribute("data-fallback")) {
            rel.innerHTML = "";
            rel.appendChild(document.importNode(track, true));
            if (section) section.hidden = false;
            initNav(rel, rel.querySelector("[data-slider-track]"));
            initAutoScroll(rel, rel.querySelector("[data-slider-track]"));
          } else if (!hasFallback && section) {
            section.hidden = true;
          }
        })
        .catch(function () {
          var s = rel.closest("[data-related-section]");
          if (s && !hasFallback) s.hidden = true;
        });
    }
  }
})();
